import React, { useState } from 'react';
import "./TechStack.css"
import Fade from 'react-reveal/Fade';
import Zoom from "react-reveal/Zoom";


const TechStack = () => {
    const data = [
        {
            name: "FullStack Developer"
        },
        {
            name: "Software Developer"
        },
        {
            name: "MERN Stack Developer"
        },
        {
            name: "Node js"
        },
        {
            name: "Next Js"
        },
        {
            name: "React Js"
        },
        {
            name: "Angular Js"
        },

        {
            name: "Data Structure & Algorithm"
        },
        {
            name: "Javascript"
        },
        {
            name: "TypeScript"
        },
        {
            name: "Java"
        },
        {
            name: "Python"
        },
        {
            name: "C++"
        },
        {
            name: "PHP"
        },
        {
            name: "PgSql"
        },





    ]

    const colors = [
        " #FFA07A",
        "#CD5C5C",
        "#F08080",
        "#0080ff",
        "#ffbf00",
        "#FF6347",
        "#FFD700",
        "#D8BFD8",
        "#7B68EE",
        "#AFEEEE",
        "#BC8F8F",
        "#800000",
        "#BC8F8F",
        "#7FFFD4",
        "#8B008B",

    ]

    const [showMoreTechStack, setShowMoreTechStack] = useState(9);
    const loadmore = () => {
        setShowMoreTechStack((prev) => prev + 3);
    }

    return (
        <div className='container techstack-section' id="tech-stack">

            <div className='section-title'>
                <h5>Tech Stack</h5>
                <span className="line"></span>
            </div>
            <div className='row'>
                {data.slice(0, showMoreTechStack).map((item, index) => (

                    <Fade right>

                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12' key={index}>

                            <div className={index == 0 ? "tech-content-marked tech-content" : "tech-content"}>
                                <span className='tech-number' style={{ backgroundColor: colors[index] }}>
                                    {index + 1}
                                </span>

                                <p>{item.name}</p>

                            </div>

                        </div>
                    </Fade>
                ))}
            </div>

            {showMoreTechStack >= data.length ? null : (
                <Zoom>
                    <span className='load-more-tech-stack' onClick={loadmore}>
                        Load More
                    </span>
                </Zoom>
            )}
        </div>
    );
};
export default TechStack;